import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalStatesContext } from "../../context/globalStates.context";
import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "../constants";
import { getDestinations, getDestinationImage, getDestinationOptions } from "../services/destinationService";

export const useGlobalSearch = () => {
  const { searchTerm, setSearchTerm } = useContext(GlobalStatesContext);   
  const navigate = useNavigate();

  const searchEvents = async () => {
    if (!searchTerm) return;

    navigate(`/events`);
  };

  return { searchTerm, setSearchTerm, searchEvents};
};

export const useFetchDestinations = (difficulty, type, isChildFriendly, isTraverse, pageNumber = 1) => {
  const { searchTerm } = useContext(GlobalStatesContext);   
  const { data = [], isLoading } = useQuery({
      queryKey: [queryKeys.destinations, searchTerm, difficulty, type, isChildFriendly, isTraverse, pageNumber],
      queryFn: () => getDestinations(searchTerm, difficulty, type, isChildFriendly, isTraverse, pageNumber)
  })

  return { data, isLoading };
};

export const useFetchDestinationOptions = () => {  
  const { data = [], isLoading } = useQuery({
      queryKey: [queryKeys.destinationOptions],
      queryFn: () => getDestinationOptions()
  })

  return { data, isLoading };
};

export const useFetchDestinationImages = (isDisplayImage, destinationId) => {  
  const { data = [], isLoading } = useQuery({
      queryKey: [queryKeys.destinationImages, destinationId],
      queryFn: () => getDestinationImage(isDisplayImage, destinationId)
  })

  return { data, isLoading };
};